@if (_tabs.length > 1) {
    <p-tabs [(value)]="_activeTab">
        <p-tablist>
            @for (tab of _tabs; track tab) {
                <p-tab [value]="tab">{{ tab }}</p-tab>
            }
        </p-tablist>
    </p-tabs>
    <br />
}

<div class="hcol-flex">
    @for (currentCol of _columns[_activeTab]; track currentCol.index) {
        <div class="floatingLabelContainer" [style]="currentCol.style">
            @for (prop of currentCol.properties; track prop) {
                <app-json-schema-form-property
                    [jsonSchemaForm]="this"
                    [path]="prop.id"
                    [name]="prop.id"
                    [details]="prop"
                    [target]="_data"
                    [targetKey]="prop.id"
                    [parentKeys]="'root'"
                    [style.display]="prop.writeOnly ? 'none' : undefined"
                    (validityChangedEvent)="onValidityChanged()"
                ></app-json-schema-form-property>
            }
        </div>
    }
</div>
